import { footerColumns } from "@/mocks/homeData";

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-950 text-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-play-circle-fill" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">中文在线</span>
            </a>
            <p className="mt-4 max-w-sm text-sm text-background-200/85 leading-relaxed">
              中文在线字幕免费高清，聚合免费小说、高清影视、漫画与听书资源，支持无广告版在线观看，
              让通勤、睡前等碎片时间都能被内容填满。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["高清影视", "免费小说", "漫画连载", "听书音频", "无广告版"].map((k) => (
                <span
                  key={k}
                  className="px-3 py-1 rounded-full bg-background-50/10 border border-background-50/15 text-xs text-background-100"
                >
                  {k}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-sm font-bold text-background-50">{col.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-200/85 hover:text-primary-300 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/70 text-center sm:text-left">
            © {new Date().getFullYear()} 中文在线字幕免费高清 · 聚合内容持续更新
          </p>
          <p className="text-xs text-background-200/70 text-center sm:text-right">
            站内检索与筛选仅作用于本页内容，不接入外部接口
          </p>
        </div>
      </div>
    </footer>
  );
}